// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"textTooltip_tooltip__lB7A3","tooltiptext":"textTooltip_tooltiptext__BYTf6","img_container":"textTooltip_img_container__lWka8","text":"textTooltip_text__QSIN2"};